import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../message";
import TemplatesService from "../../../services/templates";

export const getTemplate = createAsyncThunk(
  "templates/getTemplate",
  async (id, thunkAPI) => {
    try {
      const result = await TemplatesService.getTemplate(id);

      if (result) {
        return result;
      } else {
        thunkAPI.dispatch(setMessage(result?.data?.message || "Template not found"));
        return thunkAPI.rejectWithValue();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  emailTemplate: null,
  loading: false,
};

const emailTemplateSlice = createSlice({
  name: "emailTemplate",
  initialState,

  reducers: {
    resetEmailTemplate: (state) => {
      state.emailTemplate = null;
      state.loading = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getTemplate.pending, (state) => {
        state.loading = true;
        state.emailTemplate = null;
      })

      .addCase(getTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.emailTemplate = action.payload;
      })

      .addCase(getTemplate.rejected, (state) => {
        state.loading = false;
        state.emailTemplate = null;
      });
  },
});

export const { resetEmailTemplate } = emailTemplateSlice.actions;

export default emailTemplateSlice.reducer;
